import React, { useEffect, useState } from 'react';
import { useBreadcrumbs, useUser } from '../hooks';
import { Header, Table, Groupper, Input, Button, Icon, Pagination, Toast, Modal } from 'react-frontier';
import { Link } from 'react-router-dom';
import { getMetadataTypeName } from '../SiteUtil';
import { Metadata, SetLoading } from '../SiteClasses';
import { arrayMoveImmutable } from 'array-move';
import SortableList, { SortableItem } from 'react-easy-sort';
import { bindClick } from '../SiteUtil';
import { firstBy } from 'thenby';
import UserAccess from '../UserAccess';

import API from '../API';

const PAGE_SIZE = 20;

var FormsList = ()=>{
	var { setTitle } = useBreadcrumbs();
	var { hasAccess } = useUser();
	var [loadError, setLoadError] = useState<string>(null);
	var [forms, setForms] = useState<Metadata[]>(null);
	var [filter, setFilter] = useState<string>('');
	var [searchForms, setSearchForms] = useState<Metadata[]>(null);
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [loading, setLoading] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);
	var [sortModal, setSortModal] = useState<boolean>(false);
	var [sortForms, setSortForms] = useState<Metadata[]>([]);

	useEffect(()=>{
		setTitle('Formularios');
		get();
	}, []);

	var get = (get_page?: number) => {
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		
		setLoading(true);
		API.getFormsList(PAGE_SIZE, offset).then(res => {
			if (res.error) return setLoadError(res.message);
			return setForms(res.data);
		}).catch(err => {
			return setLoadError('Hubo un error al obtener los formularios. (GFE-1)');
		}).finally(()=>{
			setLoading(false);
		})
	};

	var onPageChange = (page: number)=>{
      setLoading(true)
		setPage(page);
		get(page);
	}

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length<3){
			return setSearchForms(null);
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	}

	var search = (query: string)=>{
		setSearching(true);
		setSearchForms(null);
		API.searchForms(query).then(res=>{
			if (res.error) return setLoadError(res.message);
			setSearchForms(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar el formulario. (SFS-1)');
		}).finally(()=>{
			setSearching(false);
		})
	}

	var showSort = ()=>{
		setSortForms(forms);
		setSortModal(true);
	}

	var onSortEnd = (old: number, newix: number)=>{
		setSortForms(arr=>arrayMoveImmutable(arr, old, newix));
	}

	var saveSort = (setLoading: SetLoading)=>{
		var order = sortForms.map(a=>a.metadata_id);
		setLoading(true);
		API.saveFormsSort(order).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Se ha actualizado el orden de los formularios');

			var frms = [...forms];
			for(var i of frms){
				var ix = order.findIndex(a=>a==i.metadata_id);
				i.sort_order = ix===-1 ? 0 : order.length-ix;
			}
			setForms(frms);
			setSortModal(false);
		}).catch(err=>{
			Toast.error('Hubo un error actualizando el orden de formularios (FSL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}

	if(loadError) { return <Header text='Error' subtext={loadError} />};
	if(!forms) { return <Header text='Cargando datos' loading/> };

	var shown_forms = searchForms || forms;

	return <div>
		<Groupper
			title={'Formularios'}
			width={900}
			style={{ marginTop: 20 }}
			titleRight={(
				<div style={{ display: 'flex', gap: '10px' }}>
					{hasAccess(UserAccess.FORMS.EDIT_FORMS) && (
						<Button icon iconName='sort' onClick={showSort} />
					)}
					{hasAccess(UserAccess.FORMS.CREATE_FORMS) && (
						<Button iconName='plus' color='black' text='Agregar' size='small' as={Link} to={`/forms/create`}/>
					)}
				</div>
			)}
		>
			<Input placeholder='Buscar...' value={filter} onChange={onSearchChange} style={{ margin: 0}} />
			<Table striped selectable fitted
				className='first last'
				style={{ marginTop: 15 }}
				headers={['ID','Pregunta', 'Tipo', 'Commentario', 'Preadded']}
				footer={(!!shown_forms && shown_forms.length >= PAGE_SIZE || page !== 0) && (
					<Table.Cell colSpan={10} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={page} onPageChange={onPageChange} hasNext={shown_forms.length>=PAGE_SIZE} />
						</div>
					</Table.Cell>
				)}
			>
				{searching || loading ? (
					<Table.Cell row className='empty' colSpan={5}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_forms.length !== 0 ? (
						shown_forms.sort(firstBy('sort_order', 'desc')).map(f => (
							<Table.Row
								collapsingIndexes={[0, 2, 3, 4, 5]}
								centeredIndexes={[4]}
								compact
								key={f.metadata_id}
								as={Link}
								to={`/forms/${f.metadata_id}`}
								data={[
									f.metadata_id,
									f.metadata_name,
									getMetadataTypeName(f.type_id),
									f.metadata_comment || <Icon name='minus'/>,
									f.preadded ? <Icon name='check' color='green'/> : <Icon name='close' color='red'/>
								]}
							/>
						))
					) : (
						<Table.Cell row className='empty' colSpan={5}>
							No se encontraron registros
						</Table.Cell>
					)
				)}
			</Table>
		</Groupper>
		<Modal open={sortModal} className='sort-forms-list' onClose={bindClick(setSortModal, false)}>
			<Modal.Header>Ordenar formularios</Modal.Header>
			<Modal.Content style={{ position: 'relative', zIndex: 1, maxHeight: 600, overflowY: 'auto', overflowX: 'hidden' }}>
				<SortableList
					onSortEnd={onSortEnd}
					className="list"
					draggedItemClassName="sort-forms-list-item-dragged"
				>
					<style>{`.sort-forms-list-item-dragged {z-index: 9999 !important;}`}</style>
					{sortForms.map(a=>(
						<SortableItem key={`SRT-FORM-${a.metadata_id}`}>
							<div className="item" style={{ padding: '10px', marginBottom: '5px', backgroundColor: '#f5f5f5', borderRadius: '4px', cursor: 'move' }}>
								<div style={{ fontWeight: 'bold' }}>{a.metadata_name}</div>
								<div style={{ fontSize: '0.9em', color: '#666' }}>{getMetadataTypeName(a.type_id)}</div>
							</div>
						</SortableItem>
					))}
				</SortableList>
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setSortModal, false)} />
				<Button text='Guardar' color='black' onClick={saveSort} />
			</Modal.Actions>
		</Modal>
	</div>
}

export default FormsList;